import { useDeviceWidth_DANGER_INTERNAL } from './useDeviceWidth_DANGER_INTERNAL.ts';

export const DeviceWidthDriver = () => {
  useDeviceWidth_DANGER_INTERNAL();

  return null;
};
